
import { Injectable } from "@angular/core";
import { TradslagMediatorService } from "../services/tradslag-mediator.service";

@Injectable({
    providedIn: "root"
})

export class TradslagMediatorHandlerService {
    tradslagMediatorList = new Map<string, TradslagMediatorService>([]);

    get(atgardGuid: string, mediatorService: TradslagMediatorService) {
        this.addIfNotExists(atgardGuid, mediatorService);
        return this.tradslagMediatorList.get(atgardGuid);
    }

    remove(atgardGuid: string) {
        if(this.tradslagMediatorList.has(atgardGuid)) {
            this.tradslagMediatorList.delete(atgardGuid);
        }
    }

    private addIfNotExists(atgardGuid: string, mediatorService: TradslagMediatorService) {
        if(!this.tradslagMediatorList.has(atgardGuid)) {
            this.tradslagMediatorList.set(atgardGuid, mediatorService);
        }
    }
}
